import { render } from "./ConsultRegionInfoView.vue?vue&type=template&id=24655b22&scoped=true"
import script from "./ConsultRegionInfoView.vue?vue&type=script&lang=js"
export * from "./ConsultRegionInfoView.vue?vue&type=script&lang=js"

import "./ConsultRegionInfoView.vue?vue&type=style&index=0&id=24655b22&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24655b22"]])

export default __exports__